import { useEffect, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './HeroSection.css';

const HeroSection = () => {
  const containerRef = useRef(null);
  const { scrollY } = useScroll();

  const backgroundY = useTransform(scrollY, [0, 500], [0, 150]);
  const buildingY = useTransform(scrollY, [0, 500], [0, 100]);
  const textOpacity = useTransform(scrollY, [0, 300], [1, 0.4]);

  return (
    <section ref={containerRef} className="hero-section">
      <motion.div
        className="hero-background"
        style={{
          y: backgroundY,
          backgroundImage: 'url(/images/home-hero/background_1.jpg)',
        }}
      />

      <motion.div
        className="hero-building"
        style={{
          y: buildingY,
          backgroundImage: 'url(/images/home-hero/building_2.png)',
        }}
      />

      <div
        className="hero-ground-layer"
        style={{
          backgroundImage: 'url(/images/home-hero/ground-layer.png)',
        }}
      />

      <div className="hero-ground" />

      <motion.div className="hero-content" style={{ opacity: textOpacity }}>
        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <span className="hero-welcome">Welcome to</span>
          <span className="hero-name gradient-text">ABHISHEK TAMAKUWALA</span>
          <span className="hero-architects gradient-text">ARCHITECTS</span>
        </motion.h1>
      </motion.div>
    </section>
  );
};

export default HeroSection;
